// extracted by mini-css-extract-plugin
export default {"menuButton":"commondropdown_menuButton__P-TBU"};